<template>
  <BreadCrumb PageTitle="Centre de vérification" />
  <VerificationList />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import VerificationList from "../../components/Verification/VerificationList.vue";

export default defineComponent({
  name: "VerificationListPage",
  components: {
    BreadCrumb,
    VerificationList,
  },
}); 
</script>